import { memo } from 'react';
import { Box, Text, Divider } from '@mantine/core';
import { FONT_WEIGHT_SEMIBOLD } from '@/constants/ui';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  title: string;
}

/**
 * SectionHeader Component
 *
 * Displays a section header with uppercase title and divider line underneath.
 * Used to visually separate sections in TaskGeneralInfo tab.
 *
 * @param title - The section title text (will be displayed in uppercase)
 */
export const SectionHeader = memo(function SectionHeader({
  title,
}: SectionHeaderProps) {
  return (
    <Box className={styles.sectionHeader}>
      <Text
        size="xs"
        fw={FONT_WEIGHT_SEMIBOLD}
        tt="uppercase"
        c="dimmed"
        className={styles.title}
      >
        {title}
      </Text>
      <Divider />
    </Box>
  );
});
